const LOCALSTORAGE_AUTH_FULL_URL = 'auth-full-url'

export default defineNuxtRouteMiddleware(async (to) => {
  // Skip on server-side rendering
  if (import.meta.server || !import.meta.client) return

  if (to.name === 'auth-login' || to.name === 'auth-callback') {
    return
  }

  if (to.query.error) {
    return navigateTo('/auth/status')
  }

  if (to.meta.public) {
    return
  }

  const { $auth0, $auth0Ready } = useNuxtApp()
  const { isAuthenticated } = $auth0()

  await $auth0Ready()

  if (isAuthenticated.value) {
    if (import.meta.client && localStorage) {
      const intendedUrl = localStorage.getItem(LOCALSTORAGE_AUTH_FULL_URL)
      if (intendedUrl) {
        localStorage.removeItem(LOCALSTORAGE_AUTH_FULL_URL)
        return navigateTo(intendedUrl)
      }
    }
    return
  }

  if (import.meta.client && localStorage) {
    localStorage.setItem(LOCALSTORAGE_AUTH_FULL_URL, to.fullPath)
  }

  return navigateTo('/auth/login')
})
